// General
import "./navbar-quick-action.scss";
import { useEffect } from "react";
// Services
import {
  useLazyGetProfileQuery,
  useLazyGetUserAioQuery,
} from "../../../../../services/data.service";
// Static Data
import userConst from "../../../../../const/userConst";
import routeConst from "../../../../../const/routeConst";
// Redux
import { useSelector, useDispatch } from "react-redux";
import { updatePaymentTag } from "../../../../../redux/store/paymentStore";
import { updateOnboardingSugarbookVerifiedDialog } from "../../../../../redux/store/dialogStore";
// react-gtm-module
import TagManager from "react-gtm-module";
// Material UI
import { ButtonBase } from "@mui/material";
// i18next
import { useTranslation } from "react-i18next";
// Custom Hooks
import IconManager from "../../../../utility/manager/icon-manager/icon-manager";
import AssetManager from "../../../../utility/manager/asset-manager/asset-manager";
import useCustomNavigate from "../../../../utility/custom-hooks/useCustomNavigate-hook";

const NavbarQuickAction = (props) => {
  const { view = "mobile" } = props;

  // API variables
  const [
    getProfile,
    {
      data: getProfileData,
      error: getProfileErrorData,
      isFetching: getProfileFetching,
      isLoading: getProfileLoading,
      isSuccess: getProfileSuccess,
      isError: getProfileError,
    },
  ] = useLazyGetProfileQuery();
  const [
    getUserAio,
    {
      data: getUserAioData,
      error: getUserAioErrorData,
      isFetching: getUserAioFetching,
      isLoading: getUserAioLoading,
      isSuccess: getUserAioSuccess,
      isError: getUserAioError,
    },
  ] = useLazyGetUserAioQuery();

  // Redux variables
  const isDaddy = useSelector((state) => state.user.isDaddy);
  const dispatch = useDispatch();

  // i18next variables
  const { t } = useTranslation();

  // Custom Hooks Functions
  const onNavigate = useCustomNavigate();

  // Lifecycle | Mounted
  useEffect(() => {
    getProfile(null, true);
    getUserAio(null, true);
  }, []);

  // Custom Hooks
  const getIcon = IconManager();
  const getAsset = AssetManager();

  // Event Handlers | Button
  const onUpgrade = () => {
    TagManager.dataLayer({
      dataLayer: {
        event: "PWA-48.2",
      },
    });

    dispatch(updatePaymentTag("navbar-quick-action-upgrade"));
    onNavigate(routeConst.upgrade.path);
  };
  const onVerifiedProfile = () => {
    TagManager.dataLayer({
      dataLayer: {
        event: "PWA-48.3",
      },
    });

    // dispatch(updateOnboardingSugarbookVerifiedDialog(true));
    onNavigate(routeConst.verify.sugarbookVerified.onboarding.path);
  };
  const onElite = () => {
    TagManager.dataLayer({
      dataLayer: {
        event: "PWA-48.4",
      },
    });

    window.open(
      `${routeConst.eliteApp.topBarInvitePath}?p=pwa&u=${getProfileData?.data?.id_int}`,
      "_blank"
    );
  };

  // Utility Functions
  const isFacialVerificationRequired = () => {
    return (
      !getProfileData?.data?.verifications?.facial?.verified ||
      !getProfileData?.data?.vp3?.verified
    );
  };

  // Render Functions
  const renderUpgradeButton = () => {
    return (
      <ButtonBase
        className={`upgrade-now-button ${
          view === "desktop" ? "desktop-upgrade-now-button" : ""
        }`}
        component="div"
        onClick={onUpgrade}
      >
        {getIcon("premiumStarIcon", "premium-star-icon")}
        {t("upgrade.upgrade")}
      </ButtonBase>
    );
  };
  const renderVerifiedButton = () => {
    return (
      <ButtonBase
        className={`verified-now-button ${
          view === "desktop" ? "desktop-verified-now-button" : ""
        }`}
        component="div"
        onClick={onVerifiedProfile}
      >
        {getIcon("verifiedProfileBadge", "verified-profile-icon")}
        {t("profile.verify")}
      </ButtonBase>
    );
  };
  const renderEliteButton = () => {
    return (
      <ButtonBase className={`elite-button`} component="div" onClick={onElite}>
        <img src={getAsset("eliteBadge")} />
        {t(
          getProfileData?.data?.role === userConst?.userRole?.sugarbaby ||
            getProfileData?.data?.role === userConst?.userRole?.maleSugarbaby
            ? "misc.elite_app_sb_description"
            : "misc.elite_app_sd_description"
        )}
      </ButtonBase>
    );
  };
  const renderButtons = () => {
    if (isDaddy) {
      if (
        getProfileData?.data?.membership_type === userConst.membershipType.free
      ) {
        return renderUpgradeButton();
      } else if (getUserAioData?.data?.modules?.elite_app_badge_enabled) {
        return renderEliteButton();
      }
    } else {
      if (isFacialVerificationRequired()) {
        return renderVerifiedButton();
      } else if (
        getProfileData?.data?.membership_type === userConst.membershipType.free
      ) {
        if (getUserAioData?.data?.modules?.elite_app_badge_enabled) {
          return renderEliteButton();
        } else {
          return renderUpgradeButton();
        }
      }
    }
    return null;
  };

  return <div id="navbar-quick-action-subcomponent">{renderButtons()}</div>;
};

export default NavbarQuickAction;
